import React, { Component } from "react";
import styled from "styled-components";
import { Col } from "styled-bootstrap-grid";
import { InputText } from "../../../../Shared/FormFields";
import { withTranslation, Trans } from "react-i18next";
import { connect } from "react-redux";
import { CloseO } from "styled-icons/evil/CloseO";
import {
  addWeekPlanner
} from "../../../../../Actions/WeekPlanner";
import { format } from "date-fns";
import { DropDownCustom } from "../../../../Shared/DropDownWeekPlanner"
class WeekPlannerForm extends Component {
  constructor(props) {
    super(props);

    this.weekObject = {
      weekNr: 1,
      weekPlannerDataList: [
        { dayId: "0", shiftTimings: undefined, shiftId: undefined },
        { dayId: "1", shiftTimings: undefined, shiftId: undefined },
        { dayId: "2", shiftTimings: undefined, shiftId: undefined },
        { dayId: "3", shiftTimings: undefined, shiftId: undefined },
        { dayId: "4", shiftTimings: undefined, shiftId: undefined },
        { dayId: "5", shiftTimings: undefined, shiftId: undefined },
        { dayId: "6", shiftTimings: undefined, shiftId: undefined }
      ]
    };

    var formAddData = {
      createdUser: props.ssoId,
      createdDate: format(new Date(), "dd/MM/yyyy"),
      maintUser: props.ssoId,
      maintDate: format(new Date(), "dd/MM/yyyy"),
      planId: null,
      isActive: "Y",
      weekPlanName: "",
      weekPlannerDetailsList: [this.weekObject]
    };
    let formData = props.editData ? JSON.parse(JSON.stringify(props.editData)) : formAddData;
    this.weekDayNames = [
      "week",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "Sunday"
    ];

    this.state = {
      planName: undefined,
      hiddenWeekNames: true,
      index: undefined,
      weekdataArrayindex: undefined,
      formData: formData,
      size: 1
    };

  }

  handleEditClick = (array, index) => {
    let i = 1;
    let formData = this.state.formData
    formData.weekPlannerDetailsList.splice(index, 1);
    formData.weekPlannerDetailsList.forEach(item => {
      item.weekNr = i
      i = i + 1;
    })
    this.setState({
      formData,
      planName: undefined, ref: false
    });
  };

  addWeekPlans = () => {
    let formData = this.state.formData;
    let weekObject = JSON.parse(JSON.stringify(this.weekObject))
    weekObject.weekNr = formData.weekPlannerDetailsList.length + 1
    formData.weekPlannerDetailsList = formData.weekPlannerDetailsList.concat([
      weekObject
    ]);
    this.setState({ formData });
  };

  handleOpenCloseDropdown = (name, planName, ) => {


    if (this.state.planName === void 0)
      this.setState(state => {
        return {
          [name]: !state[name],
          planName: planName,
        };
      }
      );
  };

  handleFormChange = (name, data, weekdataArrayindex, index) => {
    let formData = JSON.parse(JSON.stringify(this.state.formData));
    if (name === "weekPlanName") {
      formData[name] = data
    } else {
      formData.weekPlannerDetailsList[
        weekdataArrayindex
      ].weekPlannerDataList[index].shiftId = data.shiftId;
      formData.weekPlannerDetailsList[
        weekdataArrayindex
      ].weekPlannerDataList[index].shiftTimings =
        data.shiftStartTime + "-" + data.shiftEndTime;
    }
    this.setState(state => {
      return { formData, [name]: !state[name], planName: undefined };
    });
  };
  componentDidMount() {
    if (this.state.formData.weekPlannerDetailsList.length < 2) { this.addWeekPlans() }
  }

  componentDidUpdate() {
    //if (this.state.formData.weekPlannerDetailsList.length < 2) { this.addWeekPlans() }
  }
  Save = () => {
    let payload;

    if (this.props.editData) { payload = { branchNr: this.props.userDefault.branchId, weeklyPlannerList: [this.state.formData] } } else { payload = { branchNr: this.props.userDefault.branchId, weeklyPlannerList: [this.state.formData] } };
    this.props.dispatch(addWeekPlanner(payload));
    this.props.handleClose()
  };

  render() {
    const { t, handleClose } = this.props;
    const { formData } = this.state;
    let flag =
      formData.weekPlanName !== "" &&
      formData.weekPlannerDetailsList.every(weekItem => {
        let innerFlag = weekItem.weekPlannerDataList.every(item => {
          return item.shiftId !== void 0;
        });
        return innerFlag;
      });

    return (
      <Wrapper>
        <ParentDiv>
          <Cont>
            <DropDownCol md={4}>
              <InputText
                label={t("plannerTitle")}
                name="weekPlanName"
                value={formData.weekPlanName}
                color={true}
                editMode={true}
                handleChange={e =>
                  this.handleFormChange(e.target.name, e.target.value)
                }
              />
            </DropDownCol>
            <DropDownCol md={8}>
              <AddButton onClick={this.addWeekPlans}>
                +<Trans>addWeek</Trans>
              </AddButton>
            </DropDownCol>
          </Cont>
          <WeekDataDiv >
            <DIV>
              {this.weekDayNames.map(days => {
                return (
                  <COL key={days} sm="2">
                    <Trans>{days}</Trans>
                  </COL>
                );
              })}
              <COL className="removeDiv" sm="1"><Trans>remove</Trans></COL>
            </DIV>
            <WeekDataDetailDiv ref={(elem) => {
              this.tableRef = elem
            }}>

              {formData.weekPlannerDetailsList.map(
                (weekdataArray, weekdataArrayindex) => {
                  return (
                    <DIV key={weekdataArrayindex}>
                      {" "}
                      <COL sm="2">{weekdataArray.weekNr}</COL>
                      {weekdataArray.weekPlannerDataList.map((data, index) => {
                        let planName = "planName" + weekdataArrayindex + index
                        return <DropDownCustom size={this.state.size} changeSize={(data) => {
                          this.setState({ size: data })
                        }} key={planName} defaultValue={data.shiftTimings ? data.shiftTimings : t("selectShift")} handleChange={data => this.handleFormChange("hiddenWeekNames", JSON.parse(data.target.value), weekdataArrayindex, index)} data={this.props.shiftData} />

                      })}
                      <DataCol sm="1">
                        <CLoseO
                          onClick={() =>
                            this.handleEditClick(
                              weekdataArray,
                              weekdataArrayindex
                            )
                          }
                          size="20"
                        />
                      </DataCol>
                    </DIV>
                  );
                }
              )}

            </WeekDataDetailDiv>

          </WeekDataDiv>
        </ParentDiv>
        <AddCancelButton onClick={handleClose}>
          <Trans>cancel</Trans>
        </AddCancelButton>
        {(
          <AddSaveButton onClick={this.Save} disabled={!flag}>
            <Trans>save</Trans>
          </AddSaveButton>
        )}

      </Wrapper>
    );
  }
}
const mapStateToProps = ({ auth, managerTimesheetData, weekPlanner }) => {

  return {
    ssoId: auth.ssoId,
    shiftData: managerTimesheetData.payload.shiftList,
    userDefault: auth.user.defaultProfile
  };
};

export default connect(mapStateToProps)(withTranslation()(WeekPlannerForm));

const DIV = styled.div`
  display: flex;
`;
const WeekDataDetailDiv = styled.div`
&& div{
  width : 100% !important;
}
padding: 0.5px;
max-height: 134px;
overflow-y: auto
::-webkit-scrollbar {
  width: 10px;
}
::-webkit-scrollbar-track {
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  border-radius: 2px;
  background: #343a40;
}
`
const CLoseO = styled(CloseO)`
  color: #a4a4a5;
`;
const AddButton = styled.button`
  border-radius: 30px;
  margin: 0 5px;
  border: 1px solid #babec3;
  height: 38px;
  width: 129px;
  position: relative;
  left: 8px;
  float: right;
  font-size: 15px;
  background: #ffffff;
`;
const AddCancelButton = styled.button`
  position: absolute;
  bottom: 15px;
  background: #fff;
  border-radius: 30px;
  margin: 0 5px;
  border: 1px solid #babec3;
  height: 38px;
  width: 129px;
  right: 52%;
`;
const AddSaveButton = styled.button`
    border-radius: 30px;
    margin: 0 5px;
    border: 1px solid #babec3;
    height: 38px;
    width: 129px;
    color: #000;
    background: ${props => props.disabled ? "#fff" : "#cc0000"};
    color: ${props => props.disabled ? " #babec3" : "#fff"};;
    margin-top: 15px;
    position: absolute;
    bottom: 15px;
}
`;
const DropDownCol = styled(Col)`
    text-align : left
    color:grey
`;
const ParentDiv = styled.div`
    background-color: #f1f4f9;
    position: relative;
    height: auto;
    padding-top:${props => (props.height ? "0%" : "2%")};
    display:grid
    border-radius : 4px
    .iOaeVO{    padding: 0.25rem 0.7rem; !important}
`;
const Cont = styled.div`
  display: flex;
`;
const Wrapper = styled.div`
.cxFqsu{padding: 0.5rem 0.6rem 0rem 0.3rem;}
font-size :16px
font-family:Trebuchet MS;
.removeDiv{flex: 0 0 8.8% !important; } 
.DropDown-Shift{
  border: 1px solid #e8e8e8;
  overflow: hidden;
  max-height : 100px
  select{
    font-size:1vw;
    height:100%
    width:100%
    border: none;
    padding-left : 10px
    option{   margin:10px}
  }
}
&& label {font-size :16px
  font-family:Trebuchet MS;}
  padding: ${props => (props.height ? "0 0 0 0" : "0% 7% 0% 8%")};
  height: ${props => (props.height ? "auto" : "78vh")};
  overflow-y: scroll;
  box-shadow: 0px -4px 4px #00000029;
`;
const WeekDataDiv = styled.div`
  padding: 1.0px;
  border-radius: 4px;
  border: 0.5px solid #BABEC3;
`;
const COL = styled(Col)`
    background: #e1e5eb
    max-width: 11.4% !important;
    padding-right: 0px; 
    padding-left: 0px;
    font-weight: 550;
    height: 33px;
    padding-top: 5px;
    border: 1px solid #e8e8e8;
`;
const DataCol = styled(Col)`
  padding-right: 0px;
  padding-left: 0px;
  border: 1px solid #e8e8e8;
  background: #ffffff;
  height: 33px;
  padding-top: 5px;
`;
